exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".back-in-stock-form[data-v-5cca7cd5] .input {\n  text-align: left;\n}\n", ""]);

// exports
